const locale = {
  month: '月',
  day: '天',
  hour: '小时'
};
export default locale;